import { useEffect, useMemo, useState } from 'react';
import { ReactComponent as Arrow } from '../../images/v-arrow.svg';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import TextInput from '../../components/Form/TextInput';
import FileUpload from '../../components/FileUpload/FileUploadWithThumb';
import { Checkbox } from 'antd';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';
import { setFloorAppFormDeatils } from '../../redux/slice/newFloorApplication';
import { useDispatch } from 'react-redux';
import { ConvertByteToMb, IMAGE_BASE_URL } from '../../common/Constants';

const CompanyDetails = ({
  ApplicationId,
  onSubmit,
  formValues,
  methods,
  setIsStepCompleted,
  isStepCompleted,
  currentSection,
  DefaultCompletedObj
}) => {
  const dispatch = useDispatch();
  const [companyDetails, setCompanyDetails] = useState(true);
  const [showUploadDocument, setShowUploadDocument] = useState(true);
  const [UploadDocuments, setUploadDocuments] = useState({
    Company_ACRA: [],
  });
  // Wrap the defaultValues in a useCallback to prevent unnecessary re-renders
  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = methods;

  const CustomFileUpload = async ({ file, onSuccess, onError }) => {
    if (ConvertByteToMb(file.size) <= 5) {

      const formData = new FormData();
      formData.append('file[]', file);
      formData.append('module', 'flooring');
      try {
        const response = await axios
          .post('/flooring/document', formData)
          .then((resp) => {
            setValue(
              'Company_ACRA',
              getValues('Company_ACRA')?.concat(resp.data?.data)
            );
            onSuccess();
          });
      } catch (error) {
        onError(error);
      }
    }
  };

  const SubmitIncompleteForm = async (data) => {
    const dataObj = {
      companyInfo: {
        ...data,
        is_step_valid: 0,
        is_draft: 1,
      },
      Company_ACRA: data.Company_ACRA,
    };
    const resp = await axios.post(
      `flooring/application/company/${ApplicationId}`,
      dataObj
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setIsStepCompleted({
        ...isStepCompleted,
        3: false,
      });
      dispatch(
        setFloorAppFormDeatils({
          isStepCompleted: {
            ...isStepCompleted,
            3: false,
          },
          companyInfo: getValues(),
        })
      );
    }
  };

  const tempSubmit = () => {
    if (
      Object.values(getValues())?.filter((it) => it !== '' && it !== null)
        ?.length >= 12 &&
      watch('Company_ACRA')?.length > 0
    ) {
      onSubmit(getValues(), currentSection);
    } else {
      SubmitIncompleteForm(getValues());
    }
  };

  const GetFilesFormatted = (files) => {
    return files?.length > 0
      ? files?.map((url, idx) => {
        return {
          uid: idx + 1,
          name: url.name ? url.name : 'Document',
          status: 'done',
          url: `${IMAGE_BASE_URL}${url.path}`,
        };
      })
      : [];
  };

  useEffect(() => {
    reset(formValues);
  }, [formValues]);

  useEffect(() => {
  }, [watch()]);

  const OnClear = () => {
    reset(DefaultCompletedObj);
  };

  return (
    <section className='company-detail-section'>
      <div className='clear-menu-block'>
        <div
          onClick={() => setCompanyDetails(!companyDetails)}
          className='arrow-icon-block'
        >
          <span className={`${companyDetails ? null : 'down-arrow'}`}>
            <Arrow />
          </span>
          Company Details
        </div>
        <span
          className='clear-menu'
          onClick={() => {
            OnClear();
          }}
        >
          Clear
        </span>
      </div>
      {companyDetails && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(tempSubmit)}>
            <div className='input-one-line'>
              <Controller
                name='company'
                control={control}
                rules={{
                  required: 'Company Name is required',
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label='Company Name'
                    type='text'
                    name={field.name}
                    error={fieldState?.invalid ? 'error' : null}
                    placeholder='Enter a company name'
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className='w-full md:max-w-[355px]'
                  />
                )}
              />
              <Controller
                name='UEN'
                control={control}
                rules={{
                  required: 'Company UEN is required',
                }}
                render={({ field, fieldState }) => (
                  <TextInput
                    label='Company UEN'
                    type='text'
                    name={field.name}
                    error={fieldState?.invalid ? 'error' : null}
                    placeholder='Enter a company UEN'
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                    register={register}
                    className='w-full md:max-w-[355px]'
                  />
                )}
              />
            </div>
            <div className='clear-menu-block'>
              <div
                onClick={() => setShowUploadDocument(!showUploadDocument)}
                className='arrow-icon-block'
              >
                <span className={`${showUploadDocument ? null : 'down-arrow'}`}>
                  <Arrow />
                </span>
                Upload Document(s)
              </div>
              <span
                className='clear-menu'
                onClick={() => {
                  reset({
                    ...getValues(),
                    Company_ACRA: []
                  });
                }}
              >
                Clear
              </span>
            </div>
            {showUploadDocument ? (
              <>
                <div className='upload-document-section'>
                  <Controller
                    name='Company_ACRA'
                    control={control}
                    rules={{
                      required: false,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <FileUpload
                          action='your_upload_action_url'
                          
                          label='Company ACRA'
                          maxCount={10}
                          files={GetFilesFormatted(field.value)}
                          onFileUpload={(fileList) => {
                            setUploadDocuments({
                              ...UploadDocuments,
                              Company_ACRA: fileList,
                            });
                          }}
                          CustomFileUpload={CustomFileUpload}
                          onRemove={(file) => {
                            setValue(
                              'Company_ACRA',
                              getValues('Company_ACRA')?.filter(
                                (it) => it?.name !== file?.name
                              )
                            );
                          }}
                        />
                      );
                    }}
                  />
                </div>
                <h2 className='mb-5 font-medium'>Point of Contact #1</h2>
                <div className='input-one-line'>
                  <Controller
                    name='poc1_name'
                    control={control}
                    rules={{
                      required: 'Name is required',
                    }}
                    render={({ field, fieldState }) => (
                      <TextInput
                        label='Name'
                        type='text'
                        name={field.name}
                        error={fieldState?.invalid ? 'error' : null}
                        placeholder='Enter a name'
                        onChange={(e) => field.onChange(e.target.value)}
                        value={field.value}
                        register={register}
                        className='w-full md:max-w-[355px]'
                      />
                    )}
                  />
                  <Controller
                    name='poc1_email'
                    control={control}
                    rules={{
                      required: 'Email is required',
                    }}
                    render={({ field, fieldState }) => (
                      <TextInput
                        label='Email'
                        type='text'
                        name={field.name}
                        error={fieldState?.invalid ? 'error' : null}
                        placeholder='Enter a email'
                        onChange={(e) => field.onChange(e.target.value)}
                        value={field.value}
                        register={register}
                        className='w-full md:max-w-[355px]'
                      />
                    )}
                  />
                  <Controller
                    name='poc1_contactno'
                    control={control}
                    rules={{
                      required: 'Contact no is required',
                    }}
                    render={({ field, fieldState }) => (
                      <TextInput
                        label='Contact No'
                        type='text'
                        name={field.name}
                        error={fieldState?.invalid ? 'error' : null}
                        placeholder='Enter a contact no'
                        onChange={(e) => field.onChange(e.target.value)}
                        value={field.value}
                        register={register}
                        className='w-full md:max-w-[355px]'
                      />
                    )}
                  />
                </div>
                <h2 className='mb-5 font-medium'>Point of Contact #2</h2>
                <div className='input-one-line'>
                  <Controller
                    name='poc2_name'
                    control={control}
                    rules={{
                      required: 'Name is required',
                    }}
                    render={({ field, fieldState }) => (
                      <TextInput
                        label='Name'
                        type='text'
                        name={field.name}
                        error={fieldState?.invalid ? 'error' : null}
                        placeholder='Enter a name'
                        onChange={(e) => field.onChange(e.target.value)}
                        value={field.value}
                        register={register}
                        className='w-full md:max-w-[355px]'
                      />
                    )}
                  />
                  <Controller
                    name='poc2_email'
                    control={control}
                    rules={{
                      required: 'Email is required',
                    }}
                    render={({ field, fieldState }) => (
                      <TextInput
                        label='Email'
                        type='text'
                        name={field.name}
                        error={fieldState?.invalid ? 'error' : null}
                        placeholder='Enter a email'
                        onChange={(e) => field.onChange(e.target.value)}
                        value={field.value}
                        register={register}
                        className='w-full md:max-w-[355px]'
                      />
                    )}
                  />
                  <Controller
                    name='poc2_contactno'
                    control={control}
                    rules={{
                      required: 'Contact no is required',
                    }}
                    render={({ field, fieldState }) => (
                      <TextInput
                        label='Contact No'
                        type='text'
                        name={field.name}
                        error={fieldState?.invalid ? 'error' : null}
                        placeholder='Enter a contact no'
                        onChange={(e) => field.onChange(e.target.value)}
                        value={field.value}
                        register={register}
                        className='w-full md:max-w-[355px]'
                      />
                    )}
                  />
                </div>
                <div className='input-group'>
                  <label htmlFor='is_save_future' className='checkbox'>
                    <Controller
                      control={control}
                      name='is_save_future'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => (
                        <>
                          <Checkbox
                            id='is_save_future'
                            onChange={(e) => {
                              setValue(
                                'is_save_future',
                                e.target.checked ? 1 : 0
                              );
                            }}
                            checked={field.value === 1}
                            error={fieldState?.invalid ? 'error' : null}
                          />
                          Save Financial Details for Future Flooring
                          Applications
                        </>
                      )}
                    />
                  </label>
                </div>
              </>
            ) : null}
            <button
              className='sav_btn -mb-[60px] mt-6 relative z-10'
              type='submit'
              onClick={() => {
                if (
                  Object.values(getValues())?.filter(
                    (it) => it !== '' && it !== null
                  )?.length < 12
                ) {
                  tempSubmit();
                }
              }}
            >
              Save Draft
            </button>
          </form>
        </FormProvider>
      )}
    </section>
  );
};
export default CompanyDetails;
